import {Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {DwModalRef} from 'ng-quicksilver';
import {FxFfmpegUtilService} from '../fx-ffmpeg-util.service';
import {FormControl, FormGroup} from '@angular/forms';
import {DwDapHttpClient} from '@webdpt/framework';
import {FFmpegConf} from '../ffmpeg-conf';

@Component({
  selector: 'app-fx-video-compress-modal',
  templateUrl: './fx-video-compress-modal.component.html',
  styleUrls: ['./fx-video-compress-modal.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class FxVideoCompressModalComponent implements OnInit {
  @Input() title: string;
  @Input() inputVideoFile: File;
  @Input() planName: string = 'solution-480p';

  iconType: string = 'close-circle';

  @ViewChild('transcodeProgressElement') transcodeProgressElement: any; // 视频预览的页面标签属性 doc
  @ViewChild('videoPreviewElement') videoPreviewElement: any; // 视频预览的页面标签属性 doc

  public tabSelectedIndex: number = 0; // 0: 视频处理控制台 ，1: 视频处理参数面板
  public myform: FormGroup; //  表单控件
  public ffmpegConfForm: FormGroup; //  表单控件
  // 弹出层拖动控制
  draggable = true;

  private plans: Map<string, FFmpegConf> = new Map();
  // public planName: string = 'solution-480p';
  public cmd: string = '';

  // result
  public uploadResponseData: any;

  constructor(
    protected modal: DwModalRef,
    public ffmpegUtilService: FxFfmpegUtilService
  ) {
    this.myform = new FormGroup({
      inputVideoFile: new FormControl(''),
      outputVideoFile: new FormControl(''),
      // transcodeProgress: new FormControl(0),
      message: new FormControl('')
    });

    this.ffmpegConfForm = new FormGroup({
      alias: new FormControl('solution-480p'),
      cmd: new FormControl(''),
      codec: new FormControl(),
      constantRateFactor: new FormControl(28),
      preset: new FormControl('medium'),
      resolution: new FormControl(480),
      frameRate: new FormControl(24),
      videoBitrate: new FormControl(),
      audioBitrate: new FormControl(128)
    });
    this.ffmpegConfForm.valueChanges.subscribe(values => {
      this.cmd = (new FFmpegConf(values)).getCmd(undefined, undefined).join(' ');
    });
  }

  ngOnInit(): void {
    // init myfrom
    this.myform.get('inputVideoFile').setValue(this.inputVideoFile);
    if (this.ffmpegUtilService.checkFileTypeSupport(this.inputVideoFile.type)) {
      this.ffmpegUtilService.setInputVideoFile(this.inputVideoFile);
    }

    this.plans.set('solution-480p', new FFmpegConf({
      alias: 'solution-480p',
      constantRateFactor: 28,
      preset: 'medium',
      resolution: '480',
      frameRate: '24',
      audioBitrate: '128',
    }));
    this.plans.set('solution-720p', new FFmpegConf({
      alias: 'solution-720p',
      constantRateFactor: 28,
      preset: 'medium',
      resolution: '720',
      frameRate: '24',
      audioBitrate: '128',
    }));
    this.plans.set('solution-1080p', new FFmpegConf({
      alias: 'solution-1080p',
      constantRateFactor: 28,
      preset: 'medium',
      resolution: '1080',
      frameRate: '24',
      audioBitrate: '128',
    }));
    this.plans.set('solution-best-filesize', new FFmpegConf({
      alias: 'solution-best-filesize',
      constantRateFactor: 28,
      preset: 'medium',
      resolution: '720',
      frameRate: '24',
      audioBitrate: '128',
    }));
    this.plans.set('solution-best-speed', new FFmpegConf({
      alias: 'solution-best-speed',
      constantRateFactor: 28,
      preset: 'ultrafast',
      resolution: '720',
      frameRate: '24',
      audioBitrate: '128',
    }));
    this.resetPlan();
  }

  private offset(element: any): number {
    let actualTop = element.offsetTop;
    let current = element.offsetParent;
    while (current.className !== 'ant-modal-content') {
      actualTop += current.offsetTop;
      current = current.offsetParent;
    }
    return actualTop;
  }

  public onLog = (msg: string): void => {
    this.myform.get('message').setValue(msg);
    // console.log(this.myform.get('message').value);
  }

  public onProgress = ({ progress, time }): void => {
    this.transcodeProgressElement.nativeElement.value = progress * 100;
  }

  public startTranscode = (): void => {
    this.ffmpegUtilService.setInputVideoFile(this.inputVideoFile);
    this.ffmpegUtilService.setFFmpegOptions((new FFmpegConf(this.ffmpegConfForm.getRawValue())));
    this.ffmpegUtilService.setLogHandler(this.onLog);
    this.ffmpegUtilService.setProgressHandler(this.onProgress);
    this.ffmpegUtilService.transcode().then(() => {
      console.log('transcode finished');
      this.myform.get('outputVideoFile').setValue(this.ffmpegUtilService.destVideFile);
      this.videoPreviewElement.nativeElement.src = this.myform.get('outputVideoFile').value;
    });
  }

  public abortTranscode = (): void => {
    this.ffmpegUtilService.abort();
  }

  public openSettings = (): void => {
    this.tabSelectedIndex = 1 - this.tabSelectedIndex;
  }

  public resetPlan = (): void => {
    this.ffmpegConfForm.setValue(this.plans.get(this.planName).getValue());

  }

  public confirm = (): void => {
    console.log('confirm');
    this.ffmpegUtilService.uploadVideo().then((data: any) => {
      console.log(data);
      this.uploadResponseData = data;
      this.modal.triggerOk();
    });
  }

  public cancel = (): void => {
    console.log('cancel');
    this.modal.triggerCancel();
  }
}
